import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './plugins/element'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/main.scss'
import './assets/css/home.scss'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload)
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('./assets/img/error.png'),
    loading: require('./assets/img/error.png'),
    attempt: 1
})

import { baseUrl } from '@/config'
axios.defaults.baseURL = baseUrl


Vue.prototype.$http = axios
// 配置请求的根路径
axios.defaults.baseURL = baseUrl
axios.interceptors.request.use(config => {
    config.headers.Authorization = window.localStorage.getItem('token')
    return config
})
Vue.use(VideoPlayer)
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')